/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
'use strict';
export function values(obj) {
    return Object.keys(obj).map(function (key) { return obj[key]; });
}
export function isDefined(obj) {
    return typeof obj !== 'undefined';
}
